"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabeledSearchFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledSearchFieldWidget"));
const FieldSize_1 = require("../types/FieldSize");
class WCAGSearchField extends LabeledSearchFieldWidget_1.default {
    constructor(args) {
        super({
            ...args,
            fieldSizeClass: args.fieldSizeClass || FieldSize_1.FieldSize.MAX
        });
    }
    decorateLabeledSearchFieldWidgetElement(args) {
        const { fieldSizeClass } = args;
        const inputDropdownAndClearButton = this.element;
        inputDropdownAndClearButton.classList.add("flex-row");
        this.element = document.createElement("div");
        this.element.classList.add("search-field");
        if (fieldSizeClass === FieldSize_1.FieldSize.MAX) {
            this.element.classList.add(fieldSizeClass);
        }
        this.add(this.labelElement);
        this.add(inputDropdownAndClearButton);
        if (this.hintElement) {
            this.add(this.hintElement);
        }
        this.decorateWCAGSearchFieldElement(args);
    }
}
exports.default = WCAGSearchField;
//# sourceMappingURL=WCAGSearchField.js.map